import { ICommand, IQuery } from 'core-ts-types';
import { AccountIdentityDatastore, AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { TypeUtility } from 'utility-ts-type';
import { APCustomTextQuery } from '../../../../custom_texts/queries/custom_text_query';
import { APTerm } from '../../../../global/builders/ap_term_builder';
import { ILoadMarkAsMetListCommand } from '../../../../global/components/mark_as_met/commands/load_mark_as_met_list_command';
import { APUserModeConfig } from '../../../../global/components/user_mode_config/config/ap_user_mode_config';
import { APModel, IAPProgram } from '../../../../global/models/ap_model';
import { APGoalSetsQuery } from '../../../queries/ap_goal_sets_query';
import { APTermsQuery } from '../../../queries/ap_terms_query';
import { LargeCourseGroupSearchResultsQuery } from '../../large_course_group/queries/large_course_group_search_results_query';
import { IAPPlannerResourceTab } from './../../planner_resources/builders/planner_resource_tab_builder';
import { SetSelectedPlannerResourceTabCommand } from './../../planner_resources/commands/set_selected_planner_resource_tab_command';
import { APPlannerResourceTabsQuery } from './../../planner_resources/queries/planner_resource_tabs_query';

export class APMultiPlanner {
  private isEditable: boolean | string;
  private queries: { terms: APTermsQuery };
  private flags: {
    showEditGoalPreference: boolean;
    plannerTabExpanded: boolean;
    smartSearchToggle: boolean;
  };
  private models: {
    program: IAPProgram;
  };
  private programTitle: string;
  private creditsTitle: string;
  private statePrefix: string;
  private isAdvisor: boolean;
  private studentName: string;
  private printDate: string;
  private shouldShowGoalSets = false;
  private isLoadingData: boolean;
  private degreeAuditLink: string = '';
  private hideLoadingIndicatorBound: () => void;

  constructor(
    private $state: ng.ui.IStateService,
    private appConfigModel: any,
    private ngAPGoalSetsQuery: APGoalSetsQuery,
    private ngAPPlannerResourceTabsQuery: APPlannerResourceTabsQuery,
    private ngAPTermsQuery: APTermsQuery,
    private ngComponentCommunicatorService: CommunicatorService,
    private ngAPUserModeConfig: APUserModeConfig,
    private ngAccountIdentityDatastore: AccountIdentityDatastore,
    private ngAPModel: APModel,
    private ngAPCustomTextQuery: APCustomTextQuery,
    private accountModel: AccountModel,
    private loadGoalSetsCommand: ICommand,
    private ngAPStudentDetailsQuery: IQuery,
    private loadAcademicPlanCommand: ICommand,
    private loadMmAcademicPlanCommand: ICommand,
    private loadMmDegreeMapCommand: ICommand,
    private loadMmFavoriteCoursesCommand: ICommand,
    private loadAlternatePlanListCommand: ICommand,
    private loadAvailableTermsCommand: ICommand,
    private loadMarkAsMetListCommand: ILoadMarkAsMetListCommand,
    private setSelectedPlannerResourceTabCommand: SetSelectedPlannerResourceTabCommand,
    private ngLargeCourseGroupSearchResultsQuery: LargeCourseGroupSearchResultsQuery
  ) {
    this.hideLoadingIndicatorBound = this.hideLoadingIndicator.bind(this);
  }

  $onInit() {
    this.ngComponentCommunicatorService.subscribe('DEGREE_MAP_LOADING_FAILURE', this.hideLoadingIndicatorBound);
    this.ngComponentCommunicatorService.subscribe('DEGREE_MAP_LOADING_SUCCESS', this.hideLoadingIndicatorBound);
    this.isLoadingData = true;
    const studentNk =
      _4.get(this.accountModel, 'student_nk', 0) || _4.get(this.ngAPStudentDetailsQuery, 'result.id', 0);
    this.loadMmAcademicPlanCommand(studentNk);
    this.loadMmFavoriteCoursesCommand();
    this.loadAvailableTermsCommand(studentNk);
    this.shouldShowGoalSets = this.appConfigModel.isFeatureEnabled('cat-show_student_goal_sets');
    if (this.shouldShowGoalSets) {
      this.loadGoalSetsCommand(studentNk).then(() => {
        const firstStudentGoalSetId = _4.get(_4.first(this.ngAPGoalSetsQuery.result.goalSets), 'studentGoalSetId', 0);
        this.loadMmDegreeMapCommand(studentNk, firstStudentGoalSetId);
      });
    }
  }
  $onChanges() {
    this.degreeAuditLink = _4.get(this.ngAPCustomTextQuery.result['AP_DEGREE_AUDIT_URL'], 'text', '');
  }
  hideLoadingIndicator() {
    this.isLoadingData = false;
  }

  switchPlannerResourcesRegion(event: CustomEvent) {
    const selectedPlannerResourceRegionKey = _4.toUpper(
      _4.get(event, 'detail.value.key', 'MAP')
    ) as IAPPlannerResourceTab['key'];
    this.setSelectedPlannerResourceTabCommand(selectedPlannerResourceRegionKey);
  }
  get programTitleText() {
    return this.models.program
      ? `${this.models.program.name} ${this.models.program.short_credential}`
      : 'Program Title';
  }
  print() {
    // @ts-ignore
    this.printDate = `Date Printed: ${moment().format('MMMM DD, YYYY ')}`;
    window.print();
  }
}

class APMultiPlannerComponent implements ng.IComponentOptions {
  public controller: any;
  public templateUrl: any;
  public bindings: any;

  constructor() {
    this.controller = APMultiPlanner;
    (this.bindings = {
      isEditable: '@?'
    }),
      (this.templateUrl =
        'capability-ng-academic-planner/src/plan/components/planner/multi_major/multi_major_planner.html');
  }
}

angular.module('capability-ng-academic-planner').component('apMultiPlanner', new APMultiPlannerComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/planner/multi_major/multi_major_planner.ts